'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ArchiveMonth {
  month: string;
  year: string;
  count: number;
}

interface NewsArchiveProps {
  className?: string;
}

const NewsArchive: React.FC<NewsArchiveProps> = ({ className = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const archiveMonths: ArchiveMonth[] = [
    { month: 'Decembar', year: '2025', count: 8 },
    { month: 'Novembar', year: '2025', count: 12 },
    { month: 'Oktobar', year: '2025', count: 10 },
    { month: 'Septembar', year: '2025', count: 9 },
    { month: 'Avgust', year: '2025', count: 11 },
    { month: 'Juli', year: '2025', count: 7 },
  ];

  return (
    <div data-component-id="src/app/news-updates/components/NewsArchive.tsx:29:4" data-component-path="src/app/news-updates/components/NewsArchive.tsx" data-component-line="29" data-component-file="NewsArchive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`bg-card border border-border rounded-lg p-6 shadow-minimal ${className}`}>
      <button data-component-id="src/app/news-updates/components/NewsArchive.tsx:30:6" data-component-path="src/app/news-updates/components/NewsArchive.tsx" data-component-line="30" data-component-file="NewsArchive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20flex%20items-center%20justify-between%20mb-4%22%7D"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between mb-4"
      >
        <h3 data-component-id="src/app/news-updates/components/NewsArchive.tsx:34:8" data-component-path="src/app/news-updates/components/NewsArchive.tsx" data-component-line="34" data-component-file="NewsArchive.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-foreground%22%2C%22textContent%22%3A%22Arhiva%22%7D" className="text-lg font-semibold text-foreground">Arhiva</h3>
        <Icon data-component-id="src/app/news-updates/components/NewsArchive.tsx:35:8" data-component-path="src/app/news-updates/components/NewsArchive.tsx" data-component-line="35" data-component-file="NewsArchive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronDownIcon%22%7D"
          name="ChevronDownIcon"
          size={20}
          className={`text-muted-foreground transition-transform ${isExpanded ? 'rotate-180' : ''}`}
        />
      </button>

      {isExpanded && (
        <div data-component-id="src/app/news-updates/components/NewsArchive.tsx:43:8" data-component-path="src/app/news-updates/components/NewsArchive.tsx" data-component-line="43" data-component-file="NewsArchive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-2%20animate-elevation-rise%22%7D" className="space-y-2 animate-elevation-rise">
          {archiveMonths.map((archive, index) => (
            <button data-component-id="src/app/news-updates/components/NewsArchive.tsx:45:12" data-component-path="src/app/news-updates/components/NewsArchive.tsx" data-component-line="45" data-component-file="NewsArchive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20flex%20items-center%20justify-between%20px-4%20py-3%20rounded-lg%20bg-muted%20hover%3Abg-muted%2F80%20transition-smooth%20text-left%22%7D"
              key={index}
              className="w-full flex items-center justify-between px-4 py-3 rounded-lg bg-muted hover:bg-muted/80 transition-smooth text-left"
            >
              <span data-component-id="src/app/news-updates/components/NewsArchive.tsx:49:14" data-component-path="src/app/news-updates/components/NewsArchive.tsx" data-component-line="49" data-component-file="NewsArchive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%20font-medium%20text-foreground%22%7D" className="text-sm font-medium text-foreground">
                {archive.month} {archive.year}
              </span>
              <span data-component-id="src/app/news-updates/components/NewsArchive.tsx:52:14" data-component-path="src/app/news-updates/components/NewsArchive.tsx" data-component-line="52" data-component-file="NewsArchive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20px-2%20py-1%20rounded-full%20bg-primary%2F10%20text-primary%22%7D" className="text-xs px-2 py-1 rounded-full bg-primary/10 text-primary">
                {archive.count}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default NewsArchive;